module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt_BR":{"providers":{"paypal":"Paypal","pagseguro":"Pagseguro"},"status":{"paid":"Pago","waiting":"Em processamento","created":"Criada","refunded":"Estornada","cancelled":"Cancelada"}}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/Invoice/Table.vue
// module id = 107
// module chunks = 0